export default __webpack_public_path__ + "static/media/icons_on-dark-small.e3b6a7a2.svg";